export const Slide = (useAnimation, x, y, transitionOverride, variants) => {
  if (!useAnimation) return {}
  return {
    initial: {
      ...(x ? { x: x.start } : {}),
      ...(y ? { y: y.start } : {}),
    },
    animate: {
      ...(x ? { x: x.end } : {}),
      ...(y ? { y: y.end } : {}),
    },
    transition: {
      ...transitionOverride,
    },
    variants: {
      ...variants,
    },
  }
}
